module.exports = __webpack_public_path__ + "static/assets/7fe26de7358fc4e31261bb1e8038751b.png";